// extracted by mini-css-extract-plugin
export var measureBox = "_dp-0";